export const youTubeChannelLink: string = 'https://www.youtube.com/@hidden.tenths';
export const featuredVideoLink: string = 'https://www.youtube.com/embed/2iHqDDu5l38';
export const secondVideoLink: string = 'https://www.youtube.com/embed/9-nmedsGc8w';
export const thirdVideoLink: string = 'https://www.youtube.com/embed/GzSlwvH55rE';

export const submitLapFormLink: string = 'https://forms.gle/Wqy4q8nMESW6KwjL9';
export const contactFormLink: string = 'https://forms.gle/bpg7MiKk88Wd6iD46';